// Plan gating for the free-tier supplier journey.
//
// A free-tier supplier is still `organizationType: 'operator'` (it reuses the
// operator data model) but sits on a restricted plan that routes it to the
// `/lite` journey instead of the full `/operator-*` app. The plan identifier is:
//   - surfaced app-wide on GET /permissions/me  (PermissionsProvider → `plan`)
//   - stamped by the backend on organization.publicMetadata.plan at org
//     creation time, so it is available *synchronously* off the Clerk org
//     resource before /permissions/me resolves.
//
// Use publicMetadata.plan (getOrgPlan) for the fast redirect/guard decisions
// in InitPage and the /lite route guard; use /permissions/me `plan` for
// in-app feature gating.

export const Plan = {
  FreeTierSupplier: 'free_tier_supplier',
  OperatorFree: 'operator_free',
  Trial: 'trial',
  Paid: 'paid',
};

export const FREE_TIER_SUPPLIER_PLAN = Plan.FreeTierSupplier;

// Where a free-tier supplier lands.
export const LITE_HOME = '/lite';

// Synchronous plan read off the Clerk organization resource.
export function getOrgPlan(organization) {
  return organization?.publicMetadata?.plan || null;
}

export function isFreeTierSupplierPlan(plan) {
  return plan === Plan.FreeTierSupplier;
}

export function isFreeTierSupplierOrg(organization) {
  return isFreeTierSupplierPlan(getOrgPlan(organization));
}
